import { render, staticRenderFns } from "./CurriculumFiles.vue?vue&type=template&id=6e2bf74b&"
import script from "./CurriculumFiles.vue?vue&type=script&lang=js&"
export * from "./CurriculumFiles.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports